<div ngModelGroup="comboPessoa-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="{{fxFlexOffset}}">
    <combo-pesquisavel #comboFuncionario 
                       nome="pessoa-{{data}}" 
                       [itens]="dados" 
                       itemDescricao="nome"
                       itemId="id"
                       label="{{label}}"
                       [showDisplayId]="showDisplayId" 
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Escolha..."
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>

